export const socialsData = {
  github: "https://github.com/mukhiarambhu",
  linkedIn: "https://www.linkedin.com/in/rambhu-mukhia-236462215/",

  twitter: "https://twitter.com/mukhiarambhu",
  instagram: "https://www.instagram.com/_mukhia/",
  hashnode: "https://mukhiarambhu.hashnode.dev/",
};
